import React from 'react';
import styles from './ModalLoadingOverlay.module.css';

interface ModalLoadingOverlayProps {
  message?: string;
  dataTestId?: string;
}

const ModalLoadingOverlay: React.FC<ModalLoadingOverlayProps> = ({
  message = 'Processing request...',
  dataTestId = 'modal-loading'
}) => {
  return (
    <div className={styles.overlay} data-test-id={dataTestId}>
      <div className={styles.spinner}>
        <div className={styles.spinnerCircle}></div>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default ModalLoadingOverlay;
